module.exports = __webpack_public_path__ + "ffe7519ff7ea9c9e4c63effcb5e28344.jpg";